// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--yHLsE","image":"da51a739f7--image--KxWJx","message":"da51a739f7--message--lOCgv","button-wrapper":"da51a739f7--button-wrapper--xuHLb"};